import { OverlayTrigger, Tooltip as BootstrapTooltip } from "react-bootstrap"
import cx from 'classnames';
import styles from './tooltip.module.scss';

 const Tooltip = ({placement, className, content, children, disabled}) => {
  
  if(disabled) {
    return children;
  }

  return (
    <OverlayTrigger
      container={document.body}
      placement={placement}
      trigger={['focus', 'hover']}
      overlay={
        <BootstrapTooltip className={cx(styles.tooltip, className)} placement={placement}>
          {content}
        </BootstrapTooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
}

export default Tooltip;